import { render, staticRenderFns } from "./DictEntryTable.vue?vue&type=template&id=ca798e22&"
import script from "./DictEntryTable.vue?vue&type=script&lang=js&"
export * from "./DictEntryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports